import { useCallback } from 'react';
// mapboxgl types are imported elsewhere; avoid importing here to prevent unused warnings
import type { MarketZoneId } from '@app/common/static-data/energy-markets';

interface UseZoneSelectionProps {
  selectedZones: Set<string>;
  onZonesChange: (zones: MarketZoneId[]) => void;
}

export const useZoneSelection = ({ selectedZones, onZonesChange }: UseZoneSelectionProps) => {
  // Clear all selections handler
  const handleClearSelections = useCallback(() => {
    // Update global state first
    onZonesChange([]);
  }, [onZonesChange]);

  // Handle zone selection from list (or map)
  const handleZoneSelect = useCallback(
    (zoneId: string) => {
      const isCurrentlySelected = selectedZones.has(zoneId);

      // Update global state with toggled set - let useMapSelectionEffects handle visual state
      const next = new Set(selectedZones);
      if (isCurrentlySelected) {
        next.delete(zoneId);
      } else {
        next.add(zoneId);
      }
      onZonesChange(Array.from(next) as MarketZoneId[]);
    },
    [selectedZones, onZonesChange],
  );

  return {
    handleClearSelections,
    handleZoneSelect,
  };
};
